import authService from './authService';
import { readData, readList } from './apiResponse';
import type { AppUser, AppUserPatch, Profile } from '../types/planning';

class ProfileService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /** GET /auth/profile — quem sou eu nesta aplicação (AppUser) */
  async getProfile(): Promise<Profile> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get('/auth/profile');
    return readData<Profile>(response, 'Falha ao carregar o perfil');
  }

  /** GET /admin/users (só admin) */
  async listUsers(): Promise<AppUser[]> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get('/admin/users');
    return readList<AppUser>(response, 'Falha ao listar os usuários');
  }

  /** PATCH /admin/users/:id { is_active?, cac_enabled? } (só admin) — só os campos enviados mudam. */
  async patchUser(userId: number, patch: AppUserPatch): Promise<AppUser> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.patch(`/admin/users/${userId}`, patch);
    return readData<AppUser>(response, 'Falha ao atualizar o usuário');
  }

  /** PATCH /admin/users/:id {is_active} (só admin) */
  async setUserActive(userId: number, isActive: boolean): Promise<AppUser> {
    return this.patchUser(userId, { is_active: isActive });
  }

  /** PATCH /admin/users/:id {cac_enabled} (só admin) — liberação individual do Acervo CAC. */
  async setUserCac(userId: number, cacEnabled: boolean): Promise<AppUser> {
    return this.patchUser(userId, { cac_enabled: cacEnabled });
  }
}

export const profileService = new ProfileService();
export default profileService;
